export default {
  "___personal-information_page-title": "",
  "personal-information_title_address": "Address",
  "personal-information_title_phone": "Phone",
  "personal-information_title_email": "Email Address",
  "personal-information_title_password": "Password",
  "personal-information_title_dob": "Date of Birth",
  "personal-information_title_health-plan": "Health Plan Carrier",
  "___personal-information_title_related": "",
  "personal-information_label_primary-phone": "Primary Phone",
  "personal-information_label_alt-phone": "Alternate Phone",
  "personal-information_label_phone-mobile-indicator": "(mobile number)",
  "personal-information_action_update-address": "Update Address",
  "personal-information_action_update-phone": "Update Phone",
  "personal-information_action_update-email": "Update Email",
  "personal-information_action_update-password": "Update Password",
  "personal-information_action_update-dob": "Update Date of Birth",
  "personal-information_loading_updating-address": "Updating Address",
  "personal-information_loading_updating-password": "Updating Password"
};